import vue from 'vue'
import toastComponent from './toast.vue'

const ToastConstructor = vue.extend(toastComponent)

function showToast(options) {
  const text = options.text
  const top = options.top
  const type = options.type
  const duration = options.duration || 3000
  const btnText = options.btnText
  const btnClick = options.btnClick || (() => {})
  let t1, t2
  
  // 实例化一个 toast.vue
  const toastDom = new ToastConstructor({
    el: document.createElement('div'),
    data() {
      return {
        type: type,
        top: top,
        text:text,
        btnText: btnText,
        show:true,
        showContent: true
      }
    },
    computed: {
      style () {
        let style
        // 高度是下面的，居低
        if (this.top < 0) {
          style = {
            bottom: '20px'
          }
        // 无具体高，则垂直居中
        } else if (this.top) {
          style = {
            top: top + 'px'
          }
        } else {
          style = {
            top: '50%',
            transform: 'translate3d(-50%, -50% ,0)'
          }
        }
        return style
      }
    },
    methods: {
      onclick () {
        btnClick && btnClick()
        clearTimeout(t1)
        clearTimeout(t2)
        this.showContent = false
        setTimeout(() => {
            this.show = false
        }, 250)
      },
      close () {
        this.showContent = false
        this.show = false
      }
    }
  })
  document.body.appendChild(toastDom.$el)
  t1 = setTimeout(() => {toastDom.showContent = false} ,duration - 250)
  t2 = setTimeout(() => {
      toastDom.show = false
      document.body.removeChild(toastDom.$el)
  } ,duration)

  return toastDom
}
// 注册为全局组件的函数
function registryToast() {
  vue.prototype.$toast = showToast
}

export default registryToast
